import type Review from 'modules/reviews/store/models/v2/Review'

export const canEditReview = (review: Review, hasFullVisiblity: boolean): boolean => {
  if (hasFullVisiblity) {
    return true
  } else {
    const roles = review.roles
    return roles.author || roles.supervisor
  }
}
